 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import { useEffect, useRef} from 'react'
import {readInlineData} from 'relay-runtime'

import findStageById from '../utils/meetings/findStageById'
import fromStageIdToUrl from '../utils/meetings/fromStageIdToUrl'
import updateLocalStage from '../utils/relay/updateLocalStage'
import useAtmosphere from './useAtmosphere'
import useRouter from './useRouter'

const useUpdatedSafeRoute = (
  setSafeRoute,
  meetingRef
) => {
  const {history} = useRouter()
  const meeting = readInlineData(
    graphql`
      fragment useUpdatedSafeRoute_meeting on NewMeeting @inline {
        ...fromStageIdToUrl_meeting
        ...updateLocalStage_meeting
        id
        localStage {
          id
        }
        localPhase {
          id
          stages {
            id
          }
        }
        facilitatorStageId
        phases {
          id
          stages {
            id
          }
        }
      }
    `,
    meetingRef
  )
  const oldMeetingRef = useRef(meeting)
  const atmosphere = useAtmosphere()
  useEffect(() => {
    const {current: oldMeeting} = oldMeetingRef
    if (meeting === oldMeeting) {
      // required. repro: enter meeting, click to team dash, go back to meeting
      setSafeRoute(true)
      return
    }
    const {localStage, localPhase, facilitatorStageId, phases} = meeting
    const localStages = _nullishCoalesce(_optionalChain([localPhase, 'optionalAccess', _ => _.stages]), () => ( null))
    const localStageId = _nullishCoalesce(_optionalChain([localStage, 'optionalAccess', _2 => _2.id]), () => ( null))
    const oldLocalStages = _nullishCoalesce(_optionalChain([oldMeeting, 'optionalAccess', _3 => _3.localPhase, 'optionalAccess', _4 => _4.stages]), () => ( null))
    const oldLocalStageId = _optionalChain([oldMeeting, 'optionalAccess', _5 => _5.localStage, 'optionalAccess', _6 => _6.id])
    oldMeetingRef.current = meeting
    // if the stage changes or the order of the stages changes, update the url
    const isNewLocalStageId = localStageId && localStageId !== oldLocalStageId
    const isUpdatedPhase = localStages !== oldLocalStages
    if (isNewLocalStageId || isUpdatedPhase) {
      if (isUpdatedPhase && !findStageById(phases, localStageId)) {
        updateLocalStage(atmosphere, meeting, facilitatorStageId)
      }
      const nextPathname = fromStageIdToUrl(localStageId, meeting)
      if (nextPathname !== location.pathname) {
        history.replace(nextPathname)
        // do not set as unsafe (repro: start meeting, end, start again)
        return
      }
    }
    setSafeRoute(true)
  })
}

export default useUpdatedSafeRoute
